if (window.Vue) {
  window.Vue.prototype.ssr = {};
  try {
    //  将后端渲染的东西序列化成对象
    Vue.prototype.ssr.config = JSON.parse(decodeURIComponent(window.ssrConfig));
  } catch (err) {}
}

export default ({
  Vue,
  pageComponent,
  before,
  after
}) => {
  // 设置为 false 以阻止 vue 在启动时生成生产提示
  Vue.config.productionTip = false;
  //  基本的默认配置
  const vueConfig = {
    render: h => h(pageComponent)
  };
  //  实例化 vue
  window.$vm = new Vue(Object.assign({}, vueConfig, typeof before === 'function' && before(vueConfig) || {})).$mount('#app');
  after?.(window.$vm)
}